"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPERATOR_ERROR_CODES = exports.ERROR_CATALOG = exports.ERROR_AUDIENCES = void 0;
exports.isErrorCode = isErrorCode;
/**
 * A chi arriva un codice: `operatore` (una schermata della console), `consumer` (un prodotto che usa
 * le API dei consumer), `sistema` (un altro sistema, come il webhook del fornitore email, o una
 * salvaguardia interna che nessuna schermata mostra).
 */
exports.ERROR_AUDIENCES = ['operatore', 'consumer', 'sistema'];
const OPERATORE = ['operatore'];
const CONSUMER = ['consumer'];
const SISTEMA = ['sistema'];
const TUTTI = ['operatore', 'consumer'];
/** Anche il webhook del fornitore email (repliche in ingresso) li riceve. */
const TUTTI_E_SISTEMA = ['operatore', 'consumer', 'sistema'];
const OPERATORE_E_SISTEMA = ['operatore', 'sistema'];
/**
 * Catalogo dei codici d'errore (ADR-004). Ogni codice per l'operatore ha una voce di Risoluzione
 * dei problemi nella Guida (`docs/manuale/operatori/faq/risoluzione-problemi/`, campo `codici:`);
 * il test di copertura segnala quelli senza voce.
 */
exports.ERROR_CATALOG = {
    // Trasversali
    validation_error: { area: 'comune', destinatari: TUTTI },
    not_found: { area: 'comune', destinatari: TUTTI },
    payload_too_large: { area: 'comune', destinatari: TUTTI_E_SISTEMA },
    internal_error: { area: 'comune', destinatari: TUTTI_E_SISTEMA },
    network_error: { area: 'comune', destinatari: OPERATORE },
    // Accesso e Team
    'auth.session_required': { area: 'accesso', destinatari: OPERATORE },
    'auth.forbidden': { area: 'accesso', destinatari: OPERATORE },
    'auth.provider_not_configured': { area: 'accesso', destinatari: OPERATORE },
    'team.email_already_in_team': { area: 'team', destinatari: OPERATORE },
    'team.member_not_found': { area: 'team', destinatari: OPERATORE },
    'team.member_has_open_tickets': { area: 'team', destinatari: OPERATORE },
    'team.last_admin': { area: 'team', destinatari: OPERATORE },
    // Accesso dei client MCP (ADR-005): la pagina di autorizzazione li mostra all'operatore, il
    // client MCP li riceve nelle risposte OAuth (campo `code`) e su `/mcp`
    'mcp.client_not_found': { area: 'mcp', destinatari: OPERATORE_E_SISTEMA },
    'mcp.redirect_uri_not_allowed': { area: 'mcp', destinatari: OPERATORE_E_SISTEMA },
    'mcp.authorization_not_found': { area: 'mcp', destinatari: OPERATORE },
    'mcp.token_invalid': { area: 'mcp', destinatari: SISTEMA },
    // Strumenti del server MCP (#154): li riceve il client, che li riferisce all'operatore
    'mcp.rate_limited': { area: 'mcp', destinatari: OPERATORE_E_SISTEMA },
    'mcp.output_too_large': { area: 'mcp', destinatari: OPERATORE_E_SISTEMA },
    'mcp.connection_not_found': { area: 'mcp', destinatari: OPERATORE },
    'mcp.attachment_type_unsupported': { area: 'mcp', destinatari: OPERATORE_E_SISTEMA },
    'mcp.attachment_too_large': { area: 'mcp', destinatari: OPERATORE_E_SISTEMA },
    // Consumer e prodotti (Impostazioni), più il token dei consumer
    'consumers.consumer_not_found': { area: 'consumer', destinatari: OPERATORE },
    'consumers.already_revoked': { area: 'consumer', destinatari: OPERATORE },
    'consumers.environment_not_allowed': { area: 'consumer', destinatari: OPERATORE },
    'consumers.token_signing_not_configured': { area: 'consumer', destinatari: CONSUMER },
    'consumers.token_invalid': { area: 'consumer', destinatari: CONSUMER },
    'consumers.webhook_url_not_allowed': { area: 'consumer', destinatari: OPERATORE },
    'consumers.webhook_already_active': { area: 'consumer', destinatari: OPERATORE },
    'consumers.webhook_not_active': { area: 'consumer', destinatari: OPERATORE },
    'consumers.webhook_not_configured': { area: 'consumer', destinatari: OPERATORE },
    'products.product_not_found': { area: 'prodotti', destinatari: TUTTI },
    'products.name_already_used': { area: 'prodotti', destinatari: OPERATORE },
    'products.prefix_already_used': { area: 'prodotti', destinatari: OPERATORE },
    'products.prefix_locked': { area: 'prodotti', destinatari: OPERATORE },
    'products.category_exists': { area: 'prodotti', destinatari: OPERATORE },
    'products.category_not_found': { area: 'prodotti', destinatari: OPERATORE },
    'products.committente_unknown': { area: 'prodotti', destinatari: OPERATORE },
    'products.record_reference_type_exists': { area: 'prodotti', destinatari: OPERATORE },
    'products.record_reference_type_not_found': { area: 'prodotti', destinatari: OPERATORE },
    // Ricezione dei ticket dai consumer. La chiave di idempotenza serve anche a risposta e chiusura nella console
    'tickets.idempotency_key_required': { area: 'idempotenza', destinatari: TUTTI },
    'tickets.idempotency_key_invalid': { area: 'idempotenza', destinatari: TUTTI },
    'tickets.idempotency_key_reused': { area: 'idempotenza', destinatari: TUTTI },
    committente_non_autorizzato: { area: 'ricezione', destinatari: CONSUMER },
    'tickets.prodotto_discordante': { area: 'ricezione', destinatari: CONSUMER },
    'tickets.ambiente_discordante': { area: 'ricezione', destinatari: CONSUMER },
    'tickets.categoria_non_ammessa': { area: 'ricezione', destinatari: CONSUMER },
    'tickets.tipo_riferimento_non_ammesso': { area: 'ricezione', destinatari: CONSUMER },
    'tickets.campo_non_ammesso_pre_accesso': { area: 'ricezione', destinatari: CONSUMER },
    'tickets.dato_personale_non_ammesso': { area: 'ricezione', destinatari: CONSUMER },
    'tickets.segnalante_paziente_non_ammesso': { area: 'ricezione', destinatari: CONSUMER },
    'tickets.rate_limited': { area: 'ricezione', destinatari: CONSUMER },
    // Allegati: quelli della segnalazione li carica il consumer e l'operatore li apre; alcuni codici
    // valgono anche per gli allegati che l'operatore aggiunge a risposta e nota (#43)
    'tickets.allegato_richiesta_non_valida': { area: 'allegati', destinatari: TUTTI },
    'tickets.allegato_troppo_grande': { area: 'allegati', destinatari: TUTTI },
    'tickets.allegato_tipo_non_ammesso': { area: 'allegati', destinatari: TUTTI },
    'tickets.allegato_log_non_valido': { area: 'allegati', destinatari: CONSUMER },
    'tickets.allegato_gia_presente': { area: 'allegati', destinatari: CONSUMER },
    'tickets.allegato_finestra_scaduta': { area: 'allegati', destinatari: CONSUMER },
    'tickets.allegati_non_disponibili': { area: 'allegati', destinatari: TUTTI },
    'tickets.allegato_eliminato': { area: 'allegati', destinatari: OPERATORE },
    'tickets.allegati_troppi': { area: 'allegati', destinatari: OPERATORE },
    'tickets.allegati_troppo_grandi': { area: 'allegati', destinatari: OPERATORE },
    'tickets.allegati_lunghezza_richiesta': { area: 'allegati', destinatari: OPERATORE },
    'tickets.allegati_occupato': { area: 'allegati', destinatari: OPERATORE },
    // Lavorazione dei ticket nella console
    'tickets.not_found': { area: 'coda', destinatari: OPERATORE },
    'tickets.priorita_obbligatoria': { area: 'priorita', destinatari: OPERATORE },
    'tickets.membro_non_assegnabile': { area: 'assegnazione', destinatari: OPERATORE },
    'tickets.ticket_terminale': { area: 'assegnazione', destinatari: OPERATORE },
    'tickets.gia_responsabile': { area: 'assegnazione', destinatari: OPERATORE },
    'tickets.gia_collaboratore': { area: 'assegnazione', destinatari: OPERATORE },
    'tickets.non_collaboratore': { area: 'assegnazione', destinatari: OPERATORE },
    'tickets.transizione_non_ammessa': { area: 'stato', destinatari: OPERATORE_E_SISTEMA },
    'tickets.stato_cambiato': { area: 'stato', destinatari: OPERATORE_E_SISTEMA },
    'tickets.risposta_non_ammessa': { area: 'risposta', destinatari: OPERATORE },
    'tickets.risposta_non_registrata': { area: 'risposta', destinatari: OPERATORE },
    'tickets.risposta_in_invio': { area: 'risposta', destinatari: OPERATORE },
    'tickets.chiusura_non_ammessa': { area: 'chiusura', destinatari: OPERATORE },
    'tickets.correzione_non_ammessa': { area: 'chiusura', destinatari: OPERATORE },
    'tickets.descrizione_obbligatoria': { area: 'chiusura', destinatari: OPERATORE },
    'tickets.solo_responsabile': { area: 'chiusura', destinatari: OPERATORE },
    'tickets.originale_non_valido': { area: 'chiusura', destinatari: OPERATORE },
    // Bozza di risposta (#158): la riceve il client MCP, che la riferisce all'operatore
    'tickets.bozza_non_ammessa': { area: 'bozza', destinatari: OPERATORE_E_SISTEMA },
    // Email
    'mail.not_configured': { area: 'email', destinatari: OPERATORE },
    'mail.send_failed': { area: 'email', destinatari: OPERATORE },
    'mail.invalid_recipient': { area: 'email', destinatari: OPERATORE },
    'mail.ticket_not_found': { area: 'email', destinatari: SISTEMA },
    'webhooks.invalid_signature': { area: 'webhook', destinatari: SISTEMA },
    'webhooks.not_configured': { area: 'webhook', destinatari: SISTEMA },
    'webhooks.invalid_payload': { area: 'webhook', destinatari: SISTEMA },
    'webhooks.content_unavailable': { area: 'webhook', destinatari: SISTEMA },
    'posta_non_associata.non_trovata': { area: 'posta-non-associata', destinatari: OPERATORE },
    'posta_non_associata.gia_gestita': { area: 'posta-non-associata', destinatari: OPERATORE },
};
/** Vero se `value` è un codice del catalogo. */
function isErrorCode(value) {
    return typeof value === 'string' && Object.hasOwn(exports.ERROR_CATALOG, value);
}
/** I codici che possono arrivare a una schermata della console: ognuno ha la sua voce nella Guida. */
exports.OPERATOR_ERROR_CODES = Object.keys(exports.ERROR_CATALOG).filter((code) => exports.ERROR_CATALOG[code].destinatari.includes('operatore'));
//# sourceMappingURL=error-catalog.js.map